/**
 * Analytics, Tag Manager, and Conversion Tracking Hub
 * Manages GA4, GTM, Microsoft Clarity, Search Console & Event Conversions
 */

const GA_MEASUREMENT_ID = 'G-INCHPAPER2026';
const GTM_CONTAINER_ID = 'GTM-INCHPPR';
const CLARITY_PROJECT_ID = 'inchpaper-clarity';

/**
 * Initialize all Analytics and Tag Manager scripts
 */
export function initAnalytics() {
  if (typeof window === 'undefined') return;

  // 1. Google Analytics 4 (GA4)
  if (!document.getElementById('ga4-script')) {
    const gaScript = document.createElement('script');
    gaScript.id = 'ga4-script';
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gaScript);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: true,
      cookie_flags: 'SameSite=None;Secure'
    });
  }

  // 2. Google Tag Manager (GTM)
  if (!document.getElementById('gtm-script')) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;j.id='gtm-script';
    f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',GTM_CONTAINER_ID);
  }

  // 3. Microsoft Clarity
  if (!document.getElementById('clarity-script')) {
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      t.id='clarity-script';
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
  }
}

/**
 * Conversion Event: File Upload
 */
export function trackFileUpload(fileName, fileSize, pageCount) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'file_upload', {
      event_category: 'Conversion',
      event_label: fileName,
      file_size_mb: (fileSize / (1024 * 1024)).toFixed(2),
      page_count: pageCount
    });
  }
  if (typeof window !== 'undefined' && window.clarity) {
    window.clarity('set', 'uploaded_file', fileName);
  }
}

/**
 * Conversion Event: Kiosk Payment Success
 */
export function trackKioskPayment(jobId, amount, paymentMethod) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'purchase', {
      transaction_id: jobId,
      value: amount,
      currency: 'INR',
      payment_type: paymentMethod,
      items: [{ item_name: 'Inchpaper Kiosk Print Order', price: amount }]
    });
  }
}

/**
 * Conversion Event: Print Job Start
 */
export function trackPrintStart(jobId, copies) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'print_start', {
      event_category: 'Kiosk Action',
      event_label: jobId,
      copies
    });
  }
}

/**
 * Conversion Event: Google Maps Directions Click
 */
export function trackDirectionsClick(kioskId) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'get_directions', {
      event_category: 'Local SEO',
      kiosk_id: kioskId
    });
  }
}
